'use client';

import { useEffect } from 'react';

/**
 * Last-resort boundary: catches errors thrown by the root layout itself, which
 * `app/error.tsx` sits inside of and therefore cannot catch. It replaces the
 * whole document, so it must render its own <html>/<body>.
 */
export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}): React.JSX.Element {
  useEffect(() => {
    console.error('[web] root layout error', { digest: error.digest, error });
  }, [error]);

  return (
    <html lang="en">
      <body style={{ fontFamily: 'system-ui, sans-serif', padding: '2rem' }}>
        <h2>The application failed to start.</h2>
        <p>{process.env.NODE_ENV !== 'production' ? error.message : 'Details were logged on the server.'}</p>
        {error.digest && <p style={{ fontFamily: 'monospace', fontSize: 13 }}>digest: {error.digest}</p>}
        {process.env.NODE_ENV !== 'production' && error.stack && (
          <pre style={{ overflowX: 'auto', fontSize: 12 }}>{error.stack}</pre>
        )}
        <button onClick={reset} style={{ marginTop: '1rem', padding: '0.5rem 1rem' }}>
          Try again
        </button>
      </body>
    </html>
  );
}
